export default "__VITE_ASSET__g8YZaL2i__"